import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../context/ThemeContext';
import { Tooltip } from '@mui/material';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-1 bg-secondary/50 p-1 rounded-full border border-border">
      <Tooltip title="Tema Chiaro">
        <Button
          variant="ghost"
          size="icon"
          className={`h-7 w-7 rounded-full transition-all ${
            theme === 'light' 
              ? 'bg-background text-yellow-500 shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
          onClick={() => setTheme('light')}
        >
          <Sun className="h-4 w-4" />
        </Button>
      </Tooltip>
      
      <Tooltip title="Tema Scuro">
        <Button
          variant="ghost"
          size="icon"
          className={`h-7 w-7 rounded-full transition-all ${
            theme === 'dark' 
              ? 'bg-background text-indigo-400 shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
          onClick={() => setTheme('dark')}
        >
          <Moon className="h-4 w-4" />
        </Button>
      </Tooltip>

      <Tooltip title="Tema Sistema">
        <Button
          variant="ghost"
          size="icon"
          className={`h-7 w-7 rounded-full transition-all ${
            theme === 'system' 
              ? 'bg-background text-primary shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
          onClick={() => setTheme('system')}
        >
          <Monitor className="h-4 w-4" />
        </Button>
      </Tooltip>
    </div>
  );
}
